module.exports = __webpack_public_path__ + "static/media/sk.ad667891.svg";